/**
 * Row identifier.
 *
 * Kept byte-compatible with the original `uid()` (legacy/index.html:295):
 * base-36 randomness followed by a base-36 timestamp. Existing saved data is
 * full of these ids, and they are referenced across collections by
 * `studentId`, so the format has to stay recognisable and collision-free
 * against the ids already stored on the tablet.
 */
export function uid(): string {
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}
